import React, { useState } from "react"
import Dropzone from "react-dropzone"
import PropTypes from "prop-types"

import ButtonFixedVoice from "../../ButtonFixedVoice"
import Typograph from "../../../../../components/Typograph"
import ModernModal from "shared/components/ModernModal"

import styles from "./styles.css"
import parentStyles from "../styles.css"

import iconCloseRemove from "../../../../../assets/svg/fixed_voice_info_close_remove.svg"
import iconAttach from "../../../../../assets/svg/fixed_voice_attach_file.svg"

const DropFile = ({ formik }) => {
  const { setFieldValue, setFieldError, errors, values } = formik
  const [isOpen, setIsOpen] = useState(false)
  const isErrorField = errors.file
  const maxSize = 200000

  function nameSizeValidator(file) {
    const acceptedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel"
    ]
    if (!acceptedTypes.includes(file.type)) {
      return {
        message: "Arquivo inválido. Apenas arquivos .xlsx e .xls são aceitos."
      }
    }

    if (file.size > maxSize) {
      return {
        message:
          "Tamanho máximo do arquivo excedido. Ajuste o tamanho do arquivo para realizar nova solicitação."
      }
    }

    return null
  }

  const attachmentFile = (acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      const file = acceptedFiles[0]
      const validationResult = nameSizeValidator(file)

      if (validationResult) {
        setFieldError("file", validationResult.message)
      } else {
        setFieldValue("file", file)
        setFieldError("file", null)
      }
    }
  }

  const removeFile = () => {
    setFieldValue("file", null)
    setIsOpen(false)
  }

  const controlModal = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className={styles.container_drop}>
      <Dropzone
        onDrop={(acceptedFiles) => {
          attachmentFile(acceptedFiles)
        }}
        maxFiles={1}
        accept={[
          ".xlsx",
          ".xls",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel"
        ]}
      >
        {({
          getRootProps,
          getInputProps,
          isDragAccept,
          isDragActive,
          isDragReject
        }) => (
          <section
            className={`${styles.box_drop} ${
              isDragActive && styles.area_attach_valid
            } ${isDragReject && styles.area_attach_invalid}`}
          >
            <div {...getRootProps()}>
              <input {...getInputProps()} />

              {isDragAccept && <div>Solte o arquivo para anexar</div>}
              {isDragReject && <div>Arquivo inválido para anexo</div>}
              {!isDragActive && (
                <div className={styles.uploadContainer}>
                  <Typograph
                    htmlTag="span"
                    size="medium"
                    color="outer_space"
                    weight="regular"
                    classNames={styles.uploadText}
                  >
                    Arraste e solte para fazer upload do arquivo ou importe o
                    arquivo do seu computador
                  </Typograph>

                  <div className={styles.send}>
                    <img src={iconAttach} alt={"icon attachment"} />
                    <Typograph
                      htmlTag="span"
                      size="extra_small"
                      color="white"
                      weight="bold"
                    >
                      Enviar planilha
                    </Typograph>
                  </div>
                </div>
              )}
            </div>
          </section>
        )}
      </Dropzone>

      {values.file && (
        <div className={styles.file_info}>
          <div className={styles.files_attachment}>
            Planilha anexada: {values.file.path}
          </div>

          <button onClick={controlModal} className={styles.button_remove}>
            <img src={iconCloseRemove} alt={"icon to delete"} />
            Excluir
          </button>
        </div>
      )}

      {isErrorField && <div className={parentStyles.error}>{errors.file}</div>}

      <ModernModal isOpen={isOpen} onClose={controlModal} renderFooter={false}>
        <Typograph htmlTag="h1" size="medium" color="outer_space" weight="bold">
          Tem certeza que deseja remover a planilha?
        </Typograph>

        <div className={styles.confirmButton}>
          <ButtonFixedVoice name={"Confirmar"} onAction={removeFile} />
        </div>
      </ModernModal>
    </div>
  )
}

DropFile.propTypes = {
  formik: PropTypes.object.isRequired
}

export default DropFile



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/Inputs/DropFile/index.js